import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { Logo } from "./Logo";
import { CLINIC, NAV_LINKS, telLink, whatsappLink } from "../data/site";

export const Footer = () => {
  const quick = NAV_LINKS.filter((l) => l.label !== "Conditions");
  return (
    <footer className="relative bg-dash-ink text-white overflow-hidden" data-testid="footer">
      <div className="grain" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <Logo className="h-12 w-12" light />
              <div>
                <div className="font-display text-lg font-bold leading-tight">DASH Physiotherapy<br/>&amp; Speech and Hearing Clinic</div>
                <div className="mt-1 text-xs uppercase tracking-[0.18em] text-dash-teal font-accent font-semibold">Live Life Without Pain</div>
              </div>
            </div>
            <p className="text-sm text-white/60 font-accent tracking-wide mb-6">
              Physiotherapy&nbsp;·&nbsp;Speech Therapy&nbsp;·&nbsp;Hearing &amp; Audiology
            </p>
            <div className="flex items-start gap-3 text-white/75 text-sm max-w-xs">
              <MapPin className="h-5 w-5 shrink-0 text-dash-teal mt-0.5" />
              <span>{CLINIC.address}</span>
            </div>
            <div className="flex gap-3 mt-6">
              {[Facebook, Instagram, Youtube].map((Icon, i) => (
                <button
                  key={i}
                  type="button"
                  aria-label="Social media (coming soon)"
                  title="Social profile — coming soon"
                  data-testid={`social-link-${i}`}
                  className="h-10 w-10 rounded-full bg-white/8 border border-white/10 inline-flex items-center justify-center hover:bg-dash-teal transition-colors duration-300"
                >
                  <Icon className="h-4 w-4" />
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-accent text-sm uppercase tracking-[0.2em] text-white/50 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {quick.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-nav-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="text-white/75 hover:text-dash-teal transition-colors duration-300 text-sm">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-accent text-sm uppercase tracking-[0.2em] text-white/50 mb-5">Get In Touch</h4>
            <div className="space-y-3">
              <a href={telLink} data-testid="footer-call" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors">
                <span className="h-9 w-9 rounded-full bg-white/8 inline-flex items-center justify-center"><Phone className="h-4 w-4 text-dash-teal" /></span>
                {CLINIC.phone}
              </a>
              <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors">
                <span className="h-9 w-9 rounded-full bg-white/8 inline-flex items-center justify-center"><MessageCircle className="h-4 w-4 text-dash-teal" /></span>
                {CLINIC.whatsapp}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50 text-center sm:text-left">© 2026 DASH Physiotherapy and Speech and Hearing Clinic. All Rights Reserved.</p>
          <p className="text-xs text-white/40">Belpahar, Odisha · 768217</p>
        </div>
      </div>
    </footer>
  );
};
